export const useStoreClass = defineStore('StoreClass', {
    state: () => ({
        item: null,
        disabled: null,
        error: null,
    }),
    actions: {
        async getClass(idClass) {
            this.error = null;
            if (this.item?.id_class !== parseInt(idClass)) {
                this.item = null;
            }
            ({class: this.item, error: this.error} = await useEntityClass().get(idClass));
        },
        updateClassField({field, value}) {
            if (this.item[field] === undefined)
                throw new Error('Attempted to update a class field which does not exist (' + field + ').');
            this.item[field] = value;
        },
        async putClass() {
            this.error = null;
            this.disabled = true;
            ({class: this.item, error: this.error} = await useEntityClass().put(this.item.id_class, this.item));
            this.disabled = false;
        },
        async deleteClass() {
            this.error = null;
            ({error: this.error} = await useEntityClass().remove(this.item.id_class));
            if (this.error) return;
            await navigateTo('/classes');
        },
        clearError() {
            this.error = null;
        },
    },
});
